import React from "react";

import { Window } from "../window";
import { Props } from "./types";
import styles from "./styles.scss";

function Popup(props: Props) {
  return (
    <Window close={props.close}>
      <div className={styles.popup}>{props.children}</div>
    </Window>
  );
}

export { Popup };
